import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function Discount(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "Discount", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45.75 30a6 6 0 1 1 0-12v-5.25a1.5 1.5 0 0 0-1.5-1.5H3.75a1.5 1.5 0 0 0-1.5 1.5v22.5a1.5 1.5 0 0 0 1.5 1.5h40.5a1.5 1.5 0 0 0 1.5-1.5V30Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M28.5 11.25v3a.75.75 0 1 1-1.5 0v-3h1.5Zm0 10.5v-3a.75.75 0 1 0-1.5 0v3a.75.75 0 1 0 1.5 0Zm0 7.5v-3a.75.75 0 1 0-1.5 0v3a.75.75 0 1 0 1.5 0Zm0 7.5v-3a.75.75 0 1 0-1.5 0v3h1.5Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx("path", { d: "M36.75 14.25h-6v19.5h6v-19.5Z", fill: theme.vars.palette.secondary.main }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M36.75 13.5h-6V15h6v-1.5Zm0 4.5h-6v1.5h6V18Zm0 3h-6v1.5h6V21Zm0 4.5h-6V27h6v-1.5Zm0 4.5h-6v1.5h6V30Zm0 3h-6v1.5h6V33Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M9.75 30a.75.75 0 0 1-.53-1.28l10.5-10.5a.75.75 0 0 1 1.06 1.06l-10.5 10.5a.75.75 0 0 1-.53.22Zm1.5-8.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm7.5 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
Discount.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "Discount"
};
validateTidalLicense();
export {
  Discount
};
//# sourceMappingURL=Discount.js.map
